import script from "./editInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./editInfo.vue?vue&type=script&lang=ts&setup=true"

import "./editInfo.vue?vue&type=style&index=0&id=53e23eae&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53e23eae"]])

export default __exports__